export const NOTIFICATIONS_COLLECTION = 'notifications';

export const NOTIFICATION_LIST_LIMIT = 50;

/** Polling de respaldo si el listener falla (ms). */
export const NOTIFICATION_POLL_INTERVAL_MS = 60_000;
